import { InjectionToken } from "@angular/core";

export type AppName = "phone" | "signup";
export const APP_NAME = new InjectionToken<AppName>("app-name");
